import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '@app/ecsomag/user/services/user.service';
import { GlsIconRepository } from '@app/shared/services/icon-repository';
import { SiteDataService } from '@app/shared/services/site-data';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, SubscriptionLike } from 'rxjs';
import { Store } from '@ngrx/store';
import * as InputsStore from '@app/shared/store/inputs';
import { LanguageCode } from '@app/models/page';

@Component({
	selector: 'gls-header-ecsomag',
	templateUrl: 'header-ecsomag.component.html',
	styleUrls: ['header-ecsomag.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderECsomagComponent implements OnDestroy {
	public isNavbarCollapsed = true;

	public readonly user$ = this.user.user$;

	public readonly siteData$ = this.siteData.siteData$;

	public readonly isStandalonePage$ = new BehaviorSubject(false);

	private _subscriptions: SubscriptionLike[] = [];

	constructor(
		private user: UserService,
		private siteData: SiteDataService,
		public icons: GlsIconRepository,
		private _location: Location,
		private _router: Router,
		private _translate: TranslateService,
		private _uiState: Store<InputsStore.State>
	) {
		this._subscriptions.push(
			this._router.events.subscribe(event => {
				if (event instanceof NavigationEnd) {
					this.isNavbarCollapsed = true;

					const locationPath = this._location.path();
					this.isStandalonePage$.next(locationPath.startsWith('/hu/visszaru') || locationPath.startsWith('/en/parcel-return'));
				}
			})
		);
	}

	// public selectLang(lang: LanguageCode): void {
	// 	this._translate.use(lang);
	// 	this._uiState.dispatch(InputsStore.actions.setLanguage({ language: lang }));
	// 	const locationPath = this._location.path();
	// 	if (lang === 'en') {
	// 		if (locationPath.startsWith('/hu/visszaru')) {
	// 			this._router.navigateByUrl(locationPath.replace('/hu/visszaru', '/en/parcel-return'));
	// 		}
	// 	} else if (lang === 'hu') {
	// 		if (locationPath.startsWith('/en/parcel-return')) {
	// 			this._router.navigateByUrl(locationPath.replace('/en/parcel-return', '/hu/visszaru'));
	// 		}
	// 	} else {
	// 		this._router.navigate([`/${lang}`]);
	// 	}
	// }

	public selectLang(lang: LanguageCode): void {
		const locationPath = this._location.path();
		if (locationPath.startsWith('/hu/visszaru') || locationPath.startsWith('/en/parcel-return')) {
			this._translate.use(lang);
			this._uiState.dispatch(InputsStore.actions.setLanguage({ language: lang }));
			if (lang === 'en') {
				if (locationPath.startsWith('/hu/visszaru')) {
					this._router.navigateByUrl(locationPath.replace('/hu/visszaru', '/en/parcel-return'));
				}
			} else if (lang === 'hu') {
				if (locationPath.startsWith('/en/parcel-return')) {
					this._router.navigateByUrl(locationPath.replace('/en/parcel-return', '/hu/visszaru'));
				}
			}
		} else {
			window.location.href = `/${lang}`;
		}
	}

	public navigateToCalculatorModal(e: Event): void {
		e.preventDefault();
		this._router.navigate(['', { outlets: { modal: ['kalkulator'] } }]);
	}

	ngOnDestroy(): void {
		this._subscriptions.forEach(subscription => subscription.unsubscribe());
	}
}
